import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  PatchFn,
  CriteriaQuery,
  HttpProviderService,
  ILookUpData,
  FpxIHttpOption
} from '@fpx/core';
import { IHttpSuccessPayload, ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of, catchError } from 'rxjs';
import { Beneficiaries, BeneficiariesMaintanence } from './beneficiaries.model';
import { environment } from 'src/environments/environment';
@Injectable()
export class BeneficiariesService implements BaseFpxDataService<any> {

  beneDetails: any = undefined
  internationalTranDetails: any 

  constructor(private _httpProvider: HttpProviderService) { }
  create(payload: Beneficiaries, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setMethod('POST');
      httpRequest.setResource('/beneficiaries');
      let bodyContent = { "beneficiaries": payload };
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest, httpOption);
    };
  }

  findByKey(key: Beneficiaries, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindByKeyFn<Beneficiaries | null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/beneficiaries/{beneId}');
      httpRequest.addPathParameter('beneId', key.beneId);
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest, httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => this.handleResponse(res) ?? null), catchError((err: any) => {
          return of(null)
        }));

    };
  }

  handleResponse(res: any) {
    this.beneDetails = res.body?.beneficiaries ?? null
    return res.body?.beneficiaries ?? null
  }

  modify(payload: Beneficiaries, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/beneficiaries/{beneId}');
      httpRequest.addPathParameter('beneId', payload.beneId);
      httpRequest.setMethod('PUT');
      let bodyContent = { "beneficiaries": payload };
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest, httpOption);
    };
  }

  delete(payload: Beneficiaries, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/beneficiaries/{beneId}');
      httpRequest.addPathParameter('beneId', payload.beneId);
      httpRequest.setMethod('DELETE');
      let bodyContent = { "beneficiaries": payload };
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest, httpOption);
    };
  }

  patch(payload: Beneficiaries, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): PatchFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/beneficiaries/{beneId}');
      httpRequest.addPathParameter('beneId', payload.beneId);
      httpRequest.setMethod('PUT');
      let bodyContent = { "beneficiaries": payload };
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest, httpOption);
    };
  }

  isValidCriteria(CriteriaQuery: any = true) {
    var serviceData = false

    CriteriaQuery._addtionalparams.forEach((x: any) => {
      if (x?.serviceCode == "ALL") {
        serviceData = true
      } else {
        serviceData = false
      }
    })

    if (!serviceData) {
      if (CriteriaQuery._filterCriteria.size == 0) {
        return false
      }
      if (CriteriaQuery._filterCriteria.size == 1) {
        return true
      }
    } else {
      return true
    }
  }

  findAll(criteriaQuery: CriteriaQuery, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindAllFn<BeneficiariesMaintanence> {
    return () => {

      if (this.isValidCriteria(criteriaQuery)) {

      const httpRequest = new HttpRequest();
      criteriaQuery.setPaginationCriteria('1', 1000);
      criteriaQuery.addFilterCritertia('status', 'String', 'equals', {
        searchText: 'S',
      });
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/beneficiaries');
      httpRequest.setMethod('GET');
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest, httpOption)
        .pipe(
          map(
            (res: IHttpSuccessPayload<BeneficiariesMaintanence>) => {
              return {
                data: res.body?.beneficiaries || [],
                totalRowCount: res.body?.totalRowCount
              }
            }
          )
        );
      }
    };
  }


  lookup(key: any, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map(), criteriaQuery?: CriteriaQuery | undefined): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setMethod('GET');
      httpRequest.setResource('/beneficiaries');
      httpRequest.addQueryParameter('lookup', 1);
      if (criteriaQuery) {
        criteriaQuery?.addFilterCritertia('text', 'String', 'Contains', {
          searchText: key.searchText
        })
        httpRequest.setCriteriaQuery(criteriaQuery)
      }
      return this._httpProvider.invokeRestApi(httpRequest, httpOption).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data || [];
        })
      );
    };
  }

  fetchStatistics(criteriaQuery: CriteriaQuery, httpOption: Map<keyof FpxIHttpOption, Map<string, any>> = new Map()): FindAllFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource("/beneficiaries/statistics");
      httpRequest.setMethod("GET");
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest, httpOption)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body));
    };
  }
}
